<div class="centralize-all">
  <div class="announcements-container">
    <div class="announcements-container-screen-content">
      <div class="announcements-container-screen-web">
        <div class="divsearch">
          <app-search-bar
            actionText="Pesquisar"
            placeholder="Pesquise por notícias"
            (search)="filter($event)"
          ></app-search-bar>

          <app-icon-text-button
            *appIfRoles="profilesElegibleToChangeNews"
            text="Criar nova notícia"
            imagePath="../../../../assets/icons/add-news-icon.svg"
            route="news"
          ></app-icon-text-button>
        </div>

        <div class="filter" *ngIf="page">
          <div class="filters">
            <!-- ano letivo -->
            <app-year-select
              #yearSelectId
              [idSchool]="idSchool"
              [selectedYear]="selectedYear"
              (selectEvent)="changeYear($event)"
            ></app-year-select>

            <!-- turma -->
            <app-classroom-select
              *ngIf="selectedYear"
              [initialIds]="selectedIdsClassrooms"
              [year]="selectedYear"
              (selectEvent)="handleSelectClassroom($event)"
            ></app-classroom-select>

            <!-- tipo de noticia -->
            <app-type-news-select
              [initialList]="typeFilter"
              (onSelectOption)="handleSelectTypeNews($event)"
            ></app-type-news-select>

            <!-- limpar filtros -->
            <div class="reset-filter">
              <button
                class="btn-reset"
                (click)="resetFilters()"
                [disabled]="disableResetFilters"
              >
                Limpar filtros
              </button>
            </div>
          </div>
          <mat-paginator
            #paginator
            hidePageSize="true"
            [pageIndex]="0"
            [length]="page.total"
            [pageSize]="params!.limit"
            aria-label="Select page"
            (page)="handlePageEvent($event)"
          >
          </mat-paginator>
        </div>
        <div class="loading-spinner" *ngIf="loading">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>

        <div
          class="no-news-content"
          *ngIf="(!news || news.length == 0) && !loading"
        >
          <div class="no-news-image-container">
            <img
              class="image-no-news"
              src="../../../../../assets/images/no-news.svg"
            />
          </div>
          <div class="no-news-text-container">
            <h2 class="text-no-news-head">Ooops!</h2>
            <p class="text-no-news-article">
              Não conseguimos encontrar nenhuma notícia. Vamos
              <app-smart-link [customClass]="'custom-link-text'" route="news">
                criar
              </app-smart-link>
              uma nova?
            </p>
          </div>
        </div>
        <div class="announcements-cells-container">
          <div class="announcements-cells-item" *ngFor="let news of news">
            <app-card-occasion
              [occasionData]="news"
              [typeOccasion]="'NEWS'"
              [editRoute]="['/news', news.id]"
              [detailsRoute]="['/news', news.id, 'details']"
              (discardedOccasion)="reloadPageAfterDiscard($event)"
            ></app-card-occasion>
          </div>
        </div>
      </div>
      <!-- <div
        class="announcements-container-screen-content-false"
        *ngIf=""
      >
        Ainda não há dados para serem exibidos no dashboard
      </div> -->
    </div>
  </div>
</div>
